import { c as _c } from "react/compiler-runtime";
import React, { FunctionComponent, ComponentProps } from 'react';
import { useTranslation } from 'react-i18next';
import { prepareProps } from 'record-it-components/utils/propUtils';
import { PropsWithoutChildren } from 'record-it-components/utils/utilityTypes';
import { EntityName } from 'record-it-time-common/EntityName';
import { DateUtils } from 'record-it-utils/utils/DateUtils/DateUtils';
import { DurationUtils } from 'record-it-utils/utils/DurationUtils/DurationUtils';
import { WorkTimeEntry } from '../../../classes/entities/WorkTimeEntry/workTimeEntryTypes';
import { WorkTimeEntryUtils } from '../../../classes/entities/WorkTimeEntry/WorkTimeEntryUtils';
import { useTimeTrackingActivityPathName } from '../../../hooks/entity/timeTrackingActivity/useTimeTrackingActivityPathName';
import { useEntityByIdOrOriginalId } from '../../../hooks/entity/useEntityByIdOrOriginalId';
import styles from './TodaysWorkTimeInfoDetailEntry.module.css';
export type TodaysWorkTimeInfoDetailEntryProps = PropsWithoutChildren<ComponentProps<'div'>> & {
  workTimeEntry: WorkTimeEntry;
};
export const TodaysWorkTimeInfoDetailEntry: FunctionComponent<TodaysWorkTimeInfoDetailEntryProps> = React.memo(props => {
  const $ = _c(16);
  const {
    workTimeEntry,
    ...remainingProps
  } = prepareProps({
    props,
    ignoreChildren: true
  });
  const {
    t
  } = useTranslation();
  const constructionSite = useEntityByIdOrOriginalId(EntityName.ConstructionSite, workTimeEntry.constructionSiteId);
  const activityPathName = useTimeTrackingActivityPathName(workTimeEntry.timeTrackingActivityId);
  let descriptionParts;
  if ($[0] !== activityPathName || $[1] !== constructionSite) {
    descriptionParts = [];
    if (constructionSite) {
      descriptionParts.push(constructionSite.name);
    }
    if (activityPathName) {
      descriptionParts.push(activityPathName);
    }
    $[0] = activityPathName;
    $[1] = constructionSite;
    $[2] = descriptionParts;
  } else {
    descriptionParts = $[2];
  }
  const description = descriptionParts.join("; ");
  const t0 = styles;
  const t1 = DateUtils.withCurrentTimezone().formatDateRange(workTimeEntry.startDate, workTimeEntry.endDate);
  const t2 = " ";
  const t3 = "(";
  const t4 = DurationUtils.formatDurationToHourMinuteString(WorkTimeEntryUtils.getWorkTimeEntryBreakDuration(workTimeEntry));
  let t5;
  if ($[3] !== t) {
    t5 = t("components.workTime.TodaysWorkTimeInfoDetailEntry.break");
    $[3] = t;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  let t6;
  if ($[5] !== t0.durationInfo || $[6] !== t1 || $[7] !== t4 || $[8] !== t5) {
    t6 = <span className={t0.durationInfo}>{t1}{t2}{t3}{t4}{" "}{t5})</span>;
    $[5] = t0.durationInfo;
    $[6] = t1;
    $[7] = t4;
    $[8] = t5;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== description) {
    t7 = description ? <span>{"; "}{description}</span> : null;
    $[10] = description;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== remainingProps || $[13] !== t6 || $[14] !== t7) {
    t8 = <div {...remainingProps}>{t6}{t7}</div>;
    $[12] = remainingProps;
    $[13] = t6;
    $[14] = t7;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  return t8;
});